// One shared SDK instance for the web app. Plugs the SDK's pluggable
// callbacks into our local token storage + Redux session, so the rest of
// the codebase can do `sdk.users.me()` without thinking about auth.

import { createClient } from '@sss/sdk';
import { API_BASE_URL } from './config';
import { store } from '../store';
import { setTokens } from '../store/authSlice';

const ACCESS_TOKEN_KEY = 'sss.accessToken';

export const sdk = createClient({
  baseUrl: API_BASE_URL,
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN_KEY),
  // Password/MFA changes revoke every session and return a fresh pair for
  // this one — keep it, or the next request would 401.
  onTokensRefreshed: (tokens) => {
    store.dispatch(setTokens({ accessToken: tokens.access.token, refreshToken: tokens.refresh.token }));
  },
});

export type { SssClient } from '@sss/sdk';
